var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTFW)?_c('div',{staticClass:"tfw-candidate-profile"},[_c('CandidateProfileTFW')],1):_c('div',{staticClass:"candidate-profile"},[_c('CandidateProfileTalentfind')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }